<template>
  <div>
    <div class="nav_head" v-if="showHeader">
      <img class="logo" src="@/assets/homeLog.png" />
      <div class="native_left">
        <el-link @click="native_home" target="_blank" :underline="false" style="color:#666">知识头条 </el-link>|
        <el-link @click="native_resource" target="_blank" :underline="false" style="color:#666">信息技术服务</el-link>
      </div>
      <div class="native">
        <el-link @click="native_login" v-if="!userInfo" target="_blank" :underline="false" style="color:#666">登录</el-link>
        <el-dropdown @command="handleCommand" v-else>
          <span class="el-dropdown-link">
            昵称：{{userInfo.name}}
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="e">知识币：{{ userInfo.money }}</el-dropdown-item> -->
            <el-dropdown-item command="a">个人中心</el-dropdown-item>
            <!-- <el-dropdown-item command="b" v-if="userInfo.isAdmin">后台管理</el-dropdown-item> -->
            <el-dropdown-item command="c">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <router-view />

    <div class="footer">
      <div class="fock-us">
        <span>
          联系电话：023-63500773 通讯地址：重庆市北部新区洪湖西路18号2-1号
        </span>
        <span>
          版权所有：重庆市西南信息知识服务平台
          <!-- 版权所有：重庆市西信天元数据资讯有限公司 -->
        </span>
        <span>
          <a href="https://beian.miit.gov.cn" target="_blank">备案号：渝ICP备2023004648号-3</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { parseToken } from "@/services";
export default {
  name: "Home",
  data() {
    return {
      showHeader:true,
      // login: true,
      // user: false,
      // username: "",
      // news: 0, ///消息条数
      // newtrue: false, ///是否隐藏
      // admin: false,


      userInfo: null,  //用户信息
    };
  },
  created() {
    let path = this.$route.fullPath;
    this.showHeader =( path!='/login');
    this.getUserInfo()
  },

  watch: {
    //监听路由是否变化
    $route(to, from) {
      this.showHeader =( to.fullPath!='/login');
      if (from.name == 'login') {
        this.getUserInfo()
      }
    }
  },

  methods: {
    //验证用户数据并获取用户信息    
    getUserInfo() {
      parseToken().then((res = {}) => {
        let { data, message, success } = res;
        if (success) {
          this.userInfo = data;
          sessionStorage.setItem('userInfo',JSON.stringify(data));
        } else {
          this.userInfo = null;
        }
      }).catch(err=>{
        console.log(err);
      })
    },

    native_home() {
      this.$router.push({ name: "index", params: { userId: 123 } });
    },

    native_resource() {
      this.$router.push({ name: "Resource", params: { userId: 123 } });
    },

    //去登陆
    native_login() {
      this.$router.push({ name: "login", params: { userId: 123 } });
    },

    //登录后控制按钮
    handleCommand(command) {
      switch (command) {
        case "a":
          this.$router.push({ name: "Personal", params: { userId: 123 } });
          break;
        case "b":
          this.$router.push({ name: "BackManage", params: { userId: 123 } });
          break;
        case "c":
          localStorage.clear();
          sessionStorage.clear();
          this.userInfo = null;
          break;
      }
    },
  }
};
</script>

<style scoped>
.nav_head {
  width: 100%;
  height: 70px;
  /* background-color:#859CD4; */
  padding:30px 0;
  z-index: 999999;
}

.el-dropdown span {
  height: 0 !important;
  font-size: 14px !important;
  float: none !important;
  margin-left: 0 !important;
  margin-top: 0 !important;
}

.nav_head .logo {
  /* width: 300px; */
  height: 100%;
  float: left;
  margin-left: 131.86px;
  /* margin-top: 18.2px; */
}

.news {
  width: 17px;
}

.native .el-dropdown-link {
  color:#000;
  cursor: pointer;
}

.nav_head span {
  height: 24px;
  font-size: 23px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(220, 220, 221, 1);
  float: left;
  margin-left: 15.18px;
  margin-top: 21.82px;
}

.nav_head .native_left {
  float: left;
  height: 15px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(203, 203, 204, 1);
  margin-left: 65px;
  margin-top: 30px;
}

.native_left .el-link {
  font-size: 16px;
  font-weight: 500;
}

.nav_head .native {
  float: right;
  height: 15px;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(203, 203, 204, 1);
  margin-right: 100px;
  margin-top: 32px;
}

.newd {
  background: rgb(231, 13, 13);
  padding-left: 3px;
  padding-right: 3px;
  padding-top: 1px;
  color: aliceblue;
  padding-bottom: 1px;
  border-radius: 8px;
  position: absolute;
  top: -18px;
  right: 12px;
}



.footer {
  /* background-color: #252f48; */
  padding: 70px 0px;
  border-top: 1px solid #666;
}

.footer ul {
  width: 80%;
  margin: 0 auto;
  padding-inline-start: 0;
}

.footer ul::after {
  display: block;
  clear: both;
  content: '';
}

.footer ul li {
  width: 25%;
  float: left;
}

.footer ul li span:first-child {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  /* color: rgba(255, 255, 255, 1) !important; */
  line-height: 31px;
  display: block;
}

.footer ul li span:not(:first-child) {
  font-size: 20px;
  font-family: Microsoft YaHei;
  color: #859CD4 !important;
  display: block;
}

.fock-us {
  font-size: 14px;
  font-family: Microsoft YaHei;
  /* color: #ffffff !important; */
  display: block;
  margin-top: 20px;
}

.fock-us span {
  display: block;
  margin-left: 10%;
}

.pointer {
  cursor: pointer;
}</style>
